import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-transaction-status-change-confirm',
  templateUrl: './transaction-status-change-confirm.component.html',
  styleUrls: ['./transaction-status-change-confirm.component.scss']
})
export class TransactionStatusChangeConfirmComponent {
  message: string;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private translateService: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.message = this.config.data.message;
  }

  accept() {
    this.ref.close(true);
  }

  reject() {
    this.ref.close(false);
  }
}
